"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DayOneIngressWidgetSma = void 0;
const react_1 = __importStar(require("react"));
const Card_1 = require("@amzn/atoz-web/Card");
const Col_1 = require("@amzn/atoz-web/Col");
const Row_1 = require("@amzn/atoz-web/Row");
const Text_1 = require("@amzn/atoz-web/Text");
const Theme_1 = require("@amzn/atoz-web/Theme");
const react_i18next_1 = require("react-i18next");
const luxon_1 = require("luxon");
const day_one_info_rocket_svg_1 = __importDefault(require("../../assets/images/day-one-info-rocket.svg"));
const useNavigate_1 = require("../../hooks/useNavigate");
const useCandidateInfo_1 = __importDefault(require("../../hooks/useCandidateInfo"));
const getEventsFromDayOneApiResponse_1 = require("../../utils/getEventsFromDayOneApiResponse");
const translationKeys_1 = __importDefault(require("../../resources/translationKeys"));
const utils_1 = require("../../utils");
const initialiseDayOne_1 = require("../../utils/initialiseDayOne");
const DayOneInfoContent_1 = __importDefault(require("../DayOneIngressWidget/DayOneInfoContent"));
const ContentLoading_1 = __importDefault(require("../DayOneIngressWidget/ContentLoading"));
const styles_1 = __importDefault(require("../DayOneIngressWidget/styles"));
const styling_1 = require("../../framework/stencil/styling");
const StyledCard = (0, Theme_1.styledWithTheme)(Card_1.Card)(() => `
     border: none;
     display: grid;
     &:hover,
         &:focus {
             cursor: pointer;
         }
 `);
const DayOneSvgRowStyle = {
    justifyContent: 'space-between',
    alignItems: 'flex-end',
};
// eslint-disable-next-line import/prefer-default-export
const DayOneIngressWidgetSma = () => {
    const { t } = (0, react_i18next_1.useTranslation)();
    const [timeText, setTimeText] = (0, react_1.useState)('');
    const [locationText, setLocationText] = (0, react_1.useState)('');
    const dayOneSmaProps = (0, initialiseDayOne_1.getDayOneDependency)();
    const { eventInfo, isLoading, isError, invalidData, errorMessage, } = (0, useCandidateInfo_1.default)(dayOneSmaProps, true);
    const dayOneEvent = eventInfo.filter((value) => (value.type === getEventsFromDayOneApiResponse_1.EventType.DayOneShift
        || value.type === getEventsFromDayOneApiResponse_1.EventType.DayOneAndTrainingInfoSame));
    (0, react_1.useEffect)(() => {
        if (dayOneEvent.length === 1) {
            const { startDateTime } = dayOneEvent[0].details;
            setTimeText(`${t(translationKeys_1.default.starts, { replace: startDateTime.toLocaleString(luxon_1.DateTime.TIME_SIMPLE) })} ${(0, utils_1.formatTimeZone)(startDateTime)}`);
            setLocationText(dayOneEvent[0].details.location);
        }
    }, [t, dayOneEvent]);
    (0, react_1.useEffect)(() => {
        if ((isError || invalidData) && !isLoading) {
            dayOneSmaProps.emitErrorMetric();
            const metricName = isError
                ? initialiseDayOne_1.DayOneSMAMetricNames.DAY_ONE_WIDGET_API_ERROR
                : initialiseDayOne_1.DayOneSMAMetricNames.DAY_ONE_WIDGET_DATA_ERROR;
            dayOneSmaProps.emitDayOneWidgetError(errorMessage, metricName);
        }
    }, [isError, isLoading, invalidData]);
    const navigate = (0, useNavigate_1.useNavigate)();
    const onPressHandler = () => __awaiter(void 0, void 0, void 0, function* () {
        yield dayOneSmaProps.emitClickMetric();
        navigate('/newhire', {
            external: true,
        });
    });
    const styles = (0, styling_1.useStyling)(styles_1.default);
    return (react_1.default.createElement(StyledCard, { onClick: onPressHandler, "data-testid": "DayOneIngressWidget" },
        react_1.default.createElement(Row_1.Row, null,
            react_1.default.createElement(Text_1.H4, { fontSize: "T300", color: "neutral100", fontWeight: 700 }, t(translationKeys_1.default.dayOneIngressTitleHeader))),
        react_1.default.createElement(Row_1.Row, { style: DayOneSvgRowStyle },
            !isLoading ? (react_1.default.createElement(Col_1.Col, { style: styles.textCol },
                react_1.default.createElement(DayOneInfoContent_1.default, { isError: isError || invalidData, locationText: locationText, timeText: timeText, staticText: t(translationKeys_1.default.staticTextDayOneIngressWidget) })))
                : react_1.default.createElement(ContentLoading_1.default, null),
            react_1.default.createElement(Col_1.Col, { "data-testid": "svg-rocket" },
                react_1.default.createElement("img", { src: day_one_info_rocket_svg_1.default, alt: "" })))));
};
exports.DayOneIngressWidgetSma = DayOneIngressWidgetSma;
//# sourceMappingURL=DayOneIngressWidgetSma.js.map